"use client";

import { useTheme } from "next-themes";
import { Toaster as Sonner, ToasterProps } from "sonner";
const Toaster = ({
  ...props
}: ToasterProps) => {
  const {
    theme = "system"
  } = useTheme();
  return <Sonner theme={theme as ToasterProps["theme"]} className="toaster group" position="bottom-right" toastOptions={{
    classNames: {
      success: "!bg-green-600 !border-green-600",
      error: "!bg-red-600 !border-red-600",
      warning: "!bg-yellow-600 !border-yellow-600"
    }
  }} {...props} data-sentry-element="Sonner" data-sentry-component="Toaster" data-sentry-source-file="sonner.tsx" />;
};
export { Toaster };